import * as React from 'react'
import { FormValue, FileTextValue } from '../../reducers/form-values'
import { inputValueChangeFn } from './form-type-selector'
import { nl2br, targetBlankifyLinks } from '../utils'
import { errorMsg } from './build-error-msg'

export function buildCheckbox(
  data,
  value: FileTextValue,
  inputValueChange: inputValueChangeFn
): JSX.Element {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const oldValue = value.value.split(',')
    let newValue
    if (e.target.checked) {
      newValue = value.value
        ? [...oldValue, e.target.value].join(',')
        : e.target.value
    } else {
      newValue = oldValue.filter((value) => value !== e.target.value).join(',')
    }
    inputValueChange(data.qid, 'textInput', newValue)
  }
  const labelHtml = {
    __html: nl2br(targetBlankifyLinks(data.label))
  }
  const labelId = `checkbox-group-${data.qid}`

  const checkedValues = value.value.split(',')

  return (
    <div className={data.className ? data.className : 'col-xs-12'} key={data.qid}>
      <div className='input-line input-checkbox'>
        {data.label && (
          <label id={labelId} htmlFor={data.qid}>
            <span dangerouslySetInnerHTML={labelHtml} />{' '}
            <span className='fieldRequired'>{data.required && '*'}</span>
          </label>
        )}
        {data.field_options.options.map((checkbox) => (
          <label key={'' + data.qid + checkbox.value} className='label-checkbox'>
            <input
              type='checkbox'
              name={data.qid}
              checked={checkedValues.includes(checkbox.value)}
              value={checkbox.value}
              onChange={onChange}
            />
            <span>{checkbox.label}</span>
          </label>
        ))}
        {data.errorMessage && errorMsg(data.qid, data.errorMessage)}
      </div>
    </div>
  )
}
